import { Smartphone as SmartphoneIcon } from 'pcln-icons'
import React, { useState } from 'react'
import { PHONE_FORMAT } from '../constants'
import OptInForm from './OptInForm'

const DASH_INDEX = 12
const LAST_SPACE_INDEX = 8
const MAX_NUMBER_LENGTH = 17
const PREFIX_LENGTH = 4
const RIGHT_BRACKET_INDEX = 7

const OptInFormSMS = ({ signUpState, termsText, handleFormSubmit, ...props }) => {
  const [inputValue, setInputValue] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const [termsError, setTermsError] = useState(false)

  const isValidPhoneNumber = (phoneNumber) => {
    return isValidFormat(phoneNumber) && phoneNumber.length === MAX_NUMBER_LENGTH
  }

  const isValidFormat = (phoneNumber) => {
    for (let index in phoneNumber) {
      const char = phoneNumber[index]
      const hasIndex = PHONE_FORMAT?.[index]
      if ((hasIndex && PHONE_FORMAT[index] !== char) || (!hasIndex && isNaN(parseInt(char)))) {
        return false
      }
    }
    return true
  }

  const updateInputWithFormat = (value) => {
    const length = value?.length
    const isInputBeingDeleted = value?.length < inputValue?.length

    if (length < PREFIX_LENGTH) {
      if (isInputBeingDeleted) {
        return setValue('')
      } else {
        const valueWithFormat = `+1 (${value}`
        isValidFormat(valueWithFormat) && setValue(valueWithFormat)
        return
      }
    }

    if (!isValidFormat(value)) {
      return
    }

    if (length === RIGHT_BRACKET_INDEX && !isInputBeingDeleted) {
      return setValue(`${value}) `)
    }

    if (length === LAST_SPACE_INDEX && isInputBeingDeleted) {
      return setValue(value.substring(0, LAST_SPACE_INDEX - 2))
    }

    if (length === DASH_INDEX) {
      return isInputBeingDeleted ? setValue(value.substring(0, DASH_INDEX - 1)) : setValue(`${value}-`)
    }

    if (length > MAX_NUMBER_LENGTH && !isInputBeingDeleted) {
      return
    }

    setValue(value)
  }

  const handleCheckBoxChange = (e) => {
    setAgreedToTerms(e.target.checked)
    e.target.checked && setTermsError(false)
  }

  const handleSubmit = () => {
    let shouldSubmit = true

    const hasValue = inputValue.length > 0
    if (!hasValue || !isValidPhoneNumber(inputValue)) {
      setErrorMessage(
        hasValue ? 'Please check the phone number you have entered' : 'Please enter a phone number'
      )
      shouldSubmit = false
    } else {
      setErrorMessage('')
    }

    if (termsText && !agreedToTerms) {
      setTermsError(true)
      shouldSubmit = false
    }

    if (shouldSubmit) {
      setErrorMessage('')
      handleFormSubmit && handleFormSubmit({ phoneNumber: inputValue })
    }
  }

  const handleChange = (e) => updateInputWithFormat(e.target.value)

  const setValue = (value, inputValue) => {
    // istanbul ignore else
    if (value !== inputValue) {
      setErrorMessage('')
    }

    setInputValue(value)
  }

  return (
    <OptInForm
      {...props}
      agreedToTerms={agreedToTerms}
      errorMessage={errorMessage}
      inputValue={inputValue}
      placeholderIcon={<SmartphoneIcon data-testid='phone-icon' color='primary' />}
      signUpState={signUpState}
      termsError={termsError}
      termsText={termsText}
      handleChange={handleChange}
      handleCheckBoxChange={handleCheckBoxChange}
      handleSubmit={handleSubmit}
    />
  )
}

export default OptInFormSMS
